import { HISTORY_ACTION_MODE } from '@candulabs/craft';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';
import { useEditor, useNodeDisplayName } from 'craft/hooks';

interface Props {
  nodeId: string;
  prefix?: string;
}

export const ComponentName = ({ nodeId, prefix }: Props) => {
  const ref = useRef<HTMLInputElement>(null);
  const name = useNodeDisplayName(nodeId);
  const [displayName, setDisplayName] = useState(name);
  const { actions } = useEditor();
  const onSaveToCraft = (newName?: string) => {
    actions.setCustom(
      nodeId,
      (custom: any) => {
        // eslint-disable-next-line no-param-reassign
        custom.displayName = newName;
      },
      HISTORY_ACTION_MODE.THROTTLE,
      1000,
    );
  };
  const onSetName = (newName?: string) => {
    setDisplayName(newName);
    if (!newName || newName === name) {
      return;
    }
    onSaveToCraft(newName);
  };

  const handleBlur = () => {
    onSetName(ref.current?.value || name);
  };

  useEffect(() => {
    setDisplayName(name);
  }, [name]);

  const label = prefix ? `${prefix} Name` : 'Name';
  return (
    <ValueBox label={label}>
      <ValueInput
        ref={ref}
        grow
        value={displayName}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onSetName(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={(e: KeyboardEvent) => {
          if (e.key === 'Enter' || e.key === 'Escape') {
            ref.current?.blur();
          }
        }}
      />
    </ValueBox>
  );
};
